import AppStoreButtonEN from './assets/app-store/EN.svg?url';
import AppStoreButtonES from './assets/app-store/ES.svg?url';
import AppStoreButtonFR from './assets/app-store/FR.svg?url';
import AppStoreButtonPTBR from './assets/app-store/PT_BR.svg?url';
import PlayStoreButtonEN from './assets/play-store/EN.svg?url';
import PlayStoreButtonES from './assets/play-store/ES.svg?url';
import PlayStoreButtonFR from './assets/play-store/FR.svg?url';
import PlayStoreButtonPTBR from './assets/play-store/PT_BR.svg?url';

export const PLAY_STORE = {
  EN: PlayStoreButtonEN,
  ES: PlayStoreButtonES,
  FR: PlayStoreButtonFR,
  PT_BR: PlayStoreButtonPTBR
};

export const APP_STORE = {
  EN: AppStoreButtonEN,
  ES: AppStoreButtonES,
  FR: AppStoreButtonFR,
  PT_BR: AppStoreButtonPTBR
};

export const APP_STORE_LINK = 'https://sparkle.onelink.me/twwu/bannerclub01';
export const PLAY_STORE_LINK = 'https://sparkle.onelink.me/twwu/bannerclub01';
